import { render, staticRenderFns } from "./editManageBlock.vue?vue&type=template&id=6ddfefe8&scoped=true"
import script from "./editManageBlock.vue?vue&type=script&lang=js"
export * from "./editManageBlock.vue?vue&type=script&lang=js"
import style0 from "./editManageBlock.vue?vue&type=style&index=0&id=6ddfefe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddfefe8",
  null
  
)

export default component.exports